export default __webpack_public_path__ + "static/media/gallery-wip-emitter-body_05.e30d3770.jpg";